import * as Yup from 'yup';

export const CheckoutSchema = Yup.object({
    name: Yup.string().required("Your Name is required."),
    phone: Yup.string().required("Your Phone is required"),
    email: Yup.string().required("Your Email is required"),
    business_name: Yup.string().required("Business Name is required"),
    business_address : Yup.string().required("Business Address is required"),
});